
<div heading="General Info" class="container my-3 p-3 contactContent General">
  <h3>{{'PublicRecords.SearchTitle'|translate}}</h3>
  <p>{{'PublicRecords.SearchDescription'|translate}}</p>
  <p>{{'PublicRecords.Californiastate'|translate}}</p>
  <div class="info-bar">
    <p class="">{{'PropertySearch.AdditionalInfo' | translate}}</p>
    <p><a target="_blank" href="https://portal.assessor.lacounty.gov">{{'PropertySearch.AssessorPortal' | translate}}:</a> {{'PropertySearch.AssessorPortalDescription' | translate}}</p>
    <!-- <p><a target="_blank" href="https://maps.assessor.lacounty.gov">{{'PropertySearch.PIASDescription' | translate}}:</a> {{'PropertySearch.PIAS' | translate}}</p> -->
    <p><a target="_blank" href="https://propertytax.lacounty.gov">{{'PropertySearch.PropertyTaxPortal' | translate}}:</a> {{'PropertySearch.PropertyTaxPortalDescription' | translate}}</p>

  </div>
  <p [innerHTML]="'PublicRecords.PropertyownerhsipURL'|translate"></p>
  <h4>{{'PublicRecords.AssessorRecords'|translate}}</h4>
  <p><strong>{{'PublicRecords.Information2'|translate}}</strong></p>
  <ol style="margin-left: 0;">
    <li>{{'PublicRecords.records1'|translate}}</li>
    <li>{{'PublicRecords.records2'|translate}}</li>
    <li>{{'PublicRecords.records3'|translate}}</li>
    <li>{{'PublicRecords.records4'|translate}}</li>
    <li>{{'PublicRecords.records5'|translate}}</li>
    <li>{{'PublicRecords.records6'|translate}}</li>
  </ol>
  <p>{{'PublicRecords.Policy2'|translate}}</p>

  <h4>{{'PublicRecords.PublicRecForm'|translate}}</h4>
  <p><i>*{{'PublicRecords.Privateuse'|translate}}</i></p>

  <hr>


    <!-- Begin Form -->
    <div class="container my-4 contactContent" id="">
      <!-- <h3 class="page-title">{{'ContactAssessor.TitleGeneral'|translate}}</h3>
      <p style="font-style: italic"><strong>{{'ContactAssessor.Number'|translate}} </strong></p>
      <hr> -->
      <form [formGroup]="contactForm" (ngSubmit)="submit()">
        <p class="form-label">{{'ContactAssessor.Name'|translate}} <span class="color-red">*</span></p>
        <div style="display: flex; gap: 10px">
          <div class="form-group col-md-6" style="margin-bottom: 20px;">
            <input type="text" formControlName="firstName" class="form-control" id="inputFirst-General" placeholder="First">
            <div class="invalid-feedback" style="display: block">
              @if (hasError('firstName', 'required')) {
                {{'ContactAssessor.Required'|translate}}
              }
            </div>
          </div>
          <div class="form-group col-md-6">
            <input type="text" formControlName="lastName" class="form-control" id="inputLast-General" placeholder="Last">
            <div class="invalid-feedback" style="display: block">
              @if (hasError('lastName', 'required')) {
                {{ 'ContactAssessor.Required' | translate}}
              }
            </div>
          </div>
        </div>
        <div class="form-group" style="margin-bottom: 20px;">
          <p class="form-label">{{ 'ContactAssessor.Email' | translate}} <span class="color-red">*</span></p>
          <input type="email" class="form-control" formControlName="email" placeholder="Email">
          <div class="invalid-feedback" style="display: block">
            @if (hasError('email', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>
        <p class="form-label">{{ 'ContactAssessor.Phone' | translate}}  <span class="color-red">*</span></p>
        <div class="form-row">
          <div class="form-group col-12" style="margin-bottom: 20px;">
            <input class="form-control"  type="text" appPhoneMask  formControlName="phone" id="inputPhone-General"  >
            <div class="invalid-feedback" style="display: block">
              @if (hasError('phone', 'required')) {
                {{ 'ContactAssessor.Required' | translate}}
              }
            </div>
          </div>
        </div>

        <!-- <app-findProperty [title]="'PropertySearch.FindProperty' | translate"  (ParcelItem)="getAddress($event)"></app-findProperty> -->

        <p class="form-label">{{'PublicRecords.Typeof' | translate}}<span class="color-red">*</span></p>
        <div class="form-group form-row" style="margin-bottom: 20px;">
          <div class="form-check">
            <input class="form-check-input" formControlName="request" value="general" name="request" type="radio" general="true">
            <label class="form-check-label">General</label>
          </div>

          <div class="form-check">
            <input class="form-check-input" formControlName="request" value="specific"  name="request"  type="radio" specific="true">
            <label class="form-check-label">Specific</label>
          </div>
          <div class="invalid-feedback" style="display: block">
            @if (hasError('request', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>

        @if (general) {
          <div style="margin-bottom: 20px;">
            <div class="form-group">
              <label for="" class="form-label">{{'PublicRecords.RequestType' | translate}}<span class="color-red">*</span></label>
              <select formControlName="requestType" name="requestType" id="reason-honor" class="form-select">
                <option value="">Select One</option>
                <option>Assessment roll</option>
                <option>Assessment maps</option>
                <option>List of all property transferred in the last two years</option>
                <option>Organizational exemption claims and supporting documents</option>
                <option>Market data</option>
                <option>Information maintained on property characteristics</option>
                <option>Other</option>
              </select>
              <div class="invalid-feedback" style="display: block">
                @if (hasError('requestType', 'required')) {
                  {{ 'ContactAssessor.Required' | translate}}
                }
              </div>
            </div>
          </div>
        }

        @if (specific) {
          <div>
            <input type="hidden" formControlName="ain">
            <input type="hidden" formControlName="street">
            <input type="hidden" formControlName="zipCode">
            <input type="hidden" formControlName="city">
            <app-findProperty [color]="'#ffffff'" [title]="'ContactAssessor.District' | translate" [imgItem]="false"  (ParcelItem)="getAddress($event)"></app-findProperty>
            @if (parcel) {
              <div>
                <p>Address: {{parcel.SitusStreet}} {{parcel.SitusCity}} {{parcel.SitusZipCode}}</p>
              </div>
            }
          </div>
        }
        <div class="invalid-feedback" style="display: block">
          @if (hasError('ain', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
        </div>

        <p class="form-label">{{ 'PublicRecords.Includeany' | translate}}</p>
        <div class="form-group" style="margin-bottom: 20px;">

          <textarea class="form-control" formControlName="description"  id="inputDescription-General" rows="4"></textarea>
        </div>

        <p class="form-label">{{ 'ContactAssessor.Attachment' | translate}} (PDF or Docx)</p>
        <!-- <p>{{ 'PublicRecords.Ifrequesting' | translate}}</p> -->
        <div class="form-group" style="margin-bottom: 20px;">
          <app-file-upload formControlName="file" [progress]="progress"></app-file-upload>
          <div class="invalid-feedback" style="display: block">
            @if (hasError('file', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
            @if (hasError('file', 'requiredFileType')) {
              Only PDF, Docx
            }
            @if (hasError('file', 'requiredFileSize')) {
              Size to exceeds 10 MB
            }
          </div>
        </div>

        <br>

          <div class="form-group" style="margin-bottom: 15px;">
            <app-captcha [form]="contactForm" captchaFieldName="recaptchaReactive"></app-captcha>
            <div class="invalid-feedback" style="display: block">
              @if (hasError('recaptchaReactive', 'required')) {
                {{ 'ContactAssessor.Required' | translate}}
              }
            </div>
          </div>

          <button type="submit" class="btn btn-primary mr-4">Submit</button>@if (success) {
          <span>Successfully Submitted</span>
        }

      </form>

    </div>

    <!-- <p [innerHTML]="'PublicRecords.MediaInquiries'|translate"></p> -->
    <p>{{ "PublicRecords.MediaInquiries1" | translate }} <strong style="color:#AC2029"> {{ "PublicRecords.MediaInquiries2" | translate }}</strong>, <span [innerHTML]="'PublicRecords.MediaInquiries3'|translate"></span></p>

    <div class="accordion">
      <accordion [isAnimated]="true">
        <accordion-group #drop>
          <div accordion-heading>
            <span class="dropdown-item clearfix">
              {{ "PublicRecords.Additionalinfo" | translate }}
              <i
                class="mt-1 float-end"
                [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
              ></i>
            </span>
          </div>
          <p>{{ "PublicRecords.TheCaliPub" | translate }}</p>
          <p [innerHTML]="'PublicRecords.Thecountyof'|translate"></p>
          <p>{{ "PublicRecords.Requeststo" | translate }}</p>
          <p>{{ "PublicRecords.Ifamember" | translate }}</p>
          <p>{{ "PublicRecords.Recordsshall" | translate }}</p>
          <p>{{ "PublicRecords.Withinthe" | translate }}</p>
          <p>{{ "PublicRecords.Adopted" | translate }}</p>

        </accordion-group>
      </accordion>
    </div>

  </div>




  <!-- <tab heading="FAQ">FAQ</tab>
  <tab heading="Forms">Forms</tab> -->




